module.exports = __webpack_public_path__ + "static/img/Human_body_features-nb.svg.c858590e.png";